import React, { FC } from 'react';

import { graphql } from 'gatsby';
import { Drupal_ParagraphFlexiStyledSection } from 'generated/drupal-graphql';

import Default from './variants/default';
import Centered from './variants/centered';
import Quote from './variants/quote';
import CenteredHeaderUnder from './variants/centered-header-under';
import Attribution from './variants/attribution';
import LinkList from './variants/link-list';

interface FlexiStyledSectionProps {
  entity: Drupal_ParagraphFlexiStyledSection;
}

const componentMapping: Record<string, any> = {
  centered: Centered,
  default: Default,
  quote: Quote,
  centeredHeaderUnder: CenteredHeaderUnder,
  attribution: Attribution,
  linkList: LinkList,
};

const FlexiStyledSection: FC<FlexiStyledSectionProps> = ({
  entity: { fieldFlexiSectionVariant, fieldFlexiTargetSection },
}) => {
  const Variant = componentMapping[fieldFlexiSectionVariant as string];

  return Variant ? <Variant css={{ label: 'flexiStyledSection' }} entity={fieldFlexiTargetSection?.entity} /> : null;
};

export default FlexiStyledSection;

export const query = graphql`
  fragment flexiSection on Drupal_ParagraphFlexiSection {
    entityId
    fieldFlexiHeader
    fieldFlexiSubheader
    fieldFlexiImage
    fieldFlexiBody {
      processed
    }
    fieldFlexiLink {
      title
      url {
        path
      }
    }
    fieldFlexiLinkList {
      url {
        path
      }
      title
    }
    fieldFlexiLinkAsButton
    fieldFlexiUsePrimary
    fieldFlexiBackAndForthStart
  }
  fragment flexiStyledSection on Drupal_ParagraphFlexiStyledSection {
    entityId
    fieldFlexiSectionVariant
    fieldFlexiTargetSection {
      entity {
        ...flexiSection
      }
    }
  }
`;
